import apiClient from './apiClient';

const usageBaseURL = '/api/artifacts';
const adminBaseURL = '/admin/genie-artifact-quotas';

export interface GenieArtifactUsageSummary {
  organization_id: string;
  used: number;
  quota: number;
  percentage: number;
  blocked: boolean;
  period_start: string;
  period_end: string;
  is_default: boolean;
}

export interface OrganizationQuotaRow {
  organization_id: string;
  organization_name: string;
  forge_client_id: string | null;
  forge_client_name: string | null;
  quota_override: number | null;
  effective_quota: number;
  used: number;
  percentage: number;
}

export interface OrganizationQuotaListResponse {
  system_default: number;
  period_start: string;
  period_end: string;
  items: OrganizationQuotaRow[];
}

export interface SystemDefaultQuotaResponse {
  genie_artifact_default_token_quota_monthly: number;
  demo_token_quota_monthly: number;
}

export const tokenEconomyService = {
  getMyUsage: async (): Promise<GenieArtifactUsageSummary> => {
    const { data } = await apiClient.get<GenieArtifactUsageSummary>(`${usageBaseURL}/usage/me`);
    return data;
  },

  getSystemDefault: async (): Promise<SystemDefaultQuotaResponse> => {
    const { data } = await apiClient.get<SystemDefaultQuotaResponse>(`${adminBaseURL}/system-default`);
    return data;
  },

  setSystemDefault: async (value: number, demoQuota?: number): Promise<SystemDefaultQuotaResponse> => {
    const { data } = await apiClient.put<SystemDefaultQuotaResponse>(`${adminBaseURL}/system-default`, {
      genie_artifact_default_token_quota_monthly: value,
      ...(demoQuota !== undefined && { demo_token_quota_monthly: demoQuota }),
    });
    return data;
  },

  listOrganizationQuotas: async (): Promise<OrganizationQuotaListResponse> => {
    const { data } = await apiClient.get<OrganizationQuotaListResponse>(adminBaseURL);
    return data;
  },

  // Pass `null` to clear the per-org override (org inherits the system default).
  setOrganizationQuota: async (
    organizationId: string,
    value: number | null,
  ): Promise<OrganizationQuotaRow> => {
    const { data } = await apiClient.put<OrganizationQuotaRow>(`${adminBaseURL}/${organizationId}`, {
      genie_artifact_token_quota_monthly: value,
    });
    return data;
  },
};

export default tokenEconomyService;
